import { Box, Button, Typography } from '@mui/material';

import { useDisclosure } from '@hooks/useDisclosure';
import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';

const DisclosureGuidelinesIncomeStructure = () => {
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      <Button color={'inherit'} startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>

      <DisclosureGuidelineModal
        open={opened}
        onClose={close}
        title="โครงสร้างรายได้"
        description={
          <Box>
            <Typography sx={{ textIndent: 40 }}>
              ในกรณีที่บริษัทมีสายผลิตภัณฑ์หรือกลุ่มธุรกิจมากกว่า 1 สาย หรือ 1
              กลุ่ม ให้ระบุสัดส่วนรายได้จากแต่ละสายผลิตภัณฑ์หรือกลุ่มธุรกิจ
              โดยอย่างน้อยให้แสดงสัดส่วนรายได้ของสายผลิตภัณฑ์หรือกลุ่มธุรกิจที่มีมูลค่าเกินกว่าร้อยละ
              10 ของรายได้รวมตามงบกำไรขาดทุนรวม ของปีบัญชีล่าสุด
              โดยให้แสดงตามตารางดังนี้
            </Typography>
            <Typography sx={{ textIndent: 40 }}>
              ทั้งนี้
              ในกรณีที่หมายเหตุประกอบงบการเงินของบริษัทได้แสดงผลการดำเนินงานของแต่ละสายผลิตภัณฑ์ไว้ครบถ้วน
              ตามมาตรฐาน
              การบัญชีว่าด้วยการเสนอข้อมูลทางการเงินจำแนกตามส่วนงานแล้ว
              อาจอธิบายโครงสร้างรายได้เฉพาะปีล่าสุดก็ได้ (เช่น
              บริษัทมีรายได้จากการประกอบธุรกิจ A ร้อยละ 65 และธุรกิจ B ร้อยละ 35
              พร้อมทั้งอธิบายอ้างอิงถึงหมายเหตุประกอบงบการเงิน ที่เกี่ยวข้อง)
            </Typography>
            <br />
            <Typography sx={{ textDecoration: 'underline' }}>
              คำแนะนำ หรือคำอธิบายเพิ่มเติม
            </Typography>
            <Typography>
              1.
              การแบ่งแยกสายผลิตภัณฑ์หรือกลุ่มธุรกิจให้เป็นไปตามดุลยพินิจของบริษัท
              โดยควรคำนึงถึง ลักษณะของผลิตภัณฑ์หรือบริการ ลักษณะของกระบวนการผลิต
              ประเภทหรือกลุ่มลูกค้า วิธีการจัดจำหน่ายหรือการให้บริการ
              สภาพแวดล้อมทางกฎหมาย ซึ่งในสายผลิตภัณฑ์หรือกลุ่มธุรกิจเดียวกัน
              ควรมีปัจจัยดังกล่าวที่คล้ายคลึงกันหรือเกี่ยวข้องกัน ทั้งนี้
              หากสายผลิตภัณฑ์หรือกลุ่มธุรกิจใดที่มีปัจจัยบางอย่างที่คล้ายคลึงกัน
              แต่มีความเสี่ยงและผลตอบแทนที่แตกต่างกันอย่างเป็นสาระสำคัญ เช่น
              ผลิตภัณฑ์อาหารแช่แข็ง ผลิตภัณฑ์อาหารกระป๋อง เป็นต้น
              ก็ควรแยกเป็นคนละสายผลิตภัณฑ์หรือกลุ่มธุรกิจ <br />
              <br />
              2. ในกรณีที่บริษัทมีบริษัทย่อย
              ให้ใช้รายได้ตามงบการเงินรวมในการแสดงโครงสร้างรายได้
              <br />
              <br />
              3.
              ในกรณีที่สายผลิตภัณฑ์หรือกลุ่มธุรกิจใดมีมูลค่ารายได้น้อยกว่าร้อยละ
              10 ของรายได้รวมตามงบการเงินรวม บริษัทสามารถเปิดเผยรวมกับรายได้อื่น
              โดยอธิบายถึงลักษณะรายได้ จำนวน
              และสัดส่วนของรายได้ของกลุ่มธุรกิจดังกล่าวด้วย <br />
              <br />
              4. การแสดงโครงสร้างรายได้ของธุรกิจเฉพาะ <br />
              4.1 สถาบันการเงิน :
              ควรแสดงโครงสร้างรายได้แยกตามรายได้ดอกเบี้ยสุทธิ
              (หลังจากหักค่าใช้จ่ายดอกเบี้ย) และรายได้ที่ไม่ใช่ดอกเบี้ย เช่น
              รายได้ค่าธรรมเนียมและบริการสุทธิ
              กำไรจากธุรกรรมเพื่อค้าและปริวรรตเงินตราต่างประเทศ กำไรจากเงินลงทุน
              เป็นต้น ทั้งนี้ อาจแสดงโครงสร้างรายได้แยกตามแผนกลยุทธ์ของบริษัท
              หรือตามกลุ่มลูกค้าธนาคารตามความเหมาะสมประกอบด้วยก็ได้
              <br />
              4.2 บริษัทพัฒนาอสังหาริมทรัพย์ :
              ควรแสดงโครงสร้างรายได้แยกตามประเภทลักษณะธุรกิจ เช่น
              อสังหาริมทรัพย์เพื่อขาย อสังหาริมทรัพย์เพื่อให้เช่า
              และการรับจ้างก่อสร้าง เป็นต้น ทั้งนี้
              กรณีบริษัทที่มีรายได้จากการทำธุรกิจอสังหาริมทรัพย์เพื่อขาย
              บริษัทควรแยกประเภทรายได้ตามลักษณะประเภทของสินค้า (เช่น บ้านเดี่ยว
              คอนโด เป็นต้น) และหากบริษัทมีรายได้จากการรับจ้างก่อสร้าง
              บริษัทควรแยกประเภทรายได้ตามลักษณะงานที่รับจ้างก่อสร้าง (เช่น
              งานภาครัฐ งานภาคเอกชน) ด้วย <br />
              <br />
              5. การแสดงโครงสร้างรายได้กรณีที่บริษัทมีรายได้จากต่างประเทศ :
              ควรแสดงโครงสร้างรายได้ทั้งในและต่างประเทศ โดยระบุมูลค่าและสัดส่วน
              <br />
              <br /> 6.
              บริษัทควรเปิดเผยข้อมูลแยกตามแต่ละสายผลิตภัณฑ์หรือกลุ่มธุรกิจตามแนวทางดังนี้
              <br />
              6.1 ในการอธิบายการประกอบธุรกิจของแต่ละสายผลิตภัณฑ์
              ให้อธิบายทีละสายผลิตภัณฑ์หรือกลุ่มธุรกิจ
              ตามที่มีการแบ่งไว้ในตารางโครงสร้างรายได้
              โดยให้อธิบายสายผลิตภัณฑ์หรือกลุ่มธุรกิจที่ 1 ตั้งแต่หัวข้อ (1)
              ลักษณะผลิตภัณฑ์หรือบริการ (2) การตลาดและภาวะการแข่งขัน (3)
              การจัดหาผลิตภัณฑ์หรือบริการ และ (4) งานที่ยังไม่ได้ส่งมอบ
              ให้เสร็จสิ้นก่อนแล้ว จึงค่อยอธิบายสายผลิตภัณฑ์หรือกลุ่มธุรกิจที่ 2
              ภายใต้หัวข้อ (1)-(4) ต่อไป
              <br />
              6.2 ในกรณีที่บริษัทแบ่งแยกสายผลิตภัณฑ์
              เนื่องจากมีความเสี่ยงและผลตอบแทนที่แตกต่างกัน
              แต่มีปัจจัยอื่นตามหัวข้อ ตามข้อ 6.1(2)-(4) ที่เหมือนกัน (เช่น
              มีกลุ่มลูกค้า
              หรือใช้ช่องทางการจำหน่ายของแต่ละสายผลิตภัณฑ์เดียวกันเป็นต้น)
              ให้อธิบายลักษณะผลิตภัณฑ์ทีละสาย แต่อาจอธิบายหัวข้ออื่นตาม
              6.1(2)-(4) ของทุกสายผลิตภัณฑ์รวมกันก็ได้
              <br />
              6.3 หากมีสายผลิตภัณฑ์หรือกลุ่มธุรกิจเดียว
              อาจไม่ต้องแยกหัวข้อนี้ไว้ต่างหาก
              โดยอาจอธิบายไว้ภายใต้หัวข้อลักษณะการประกอบธุรกิจก็ได้
              <br />
              6.4 หากมียี่ห้อ ลิขสิทธิ์ เครื่องหมายการค้า สิทธิบัตร สัมปทาน
              หรือใบอนุญาตสำคัญ ที่ใช้ในการประกอบธุรกิจ ให้ระบุด้วย
              <br />
              6.5 กรณีบริษัทพัฒนาอสังหาริมทรัพย์ :
              ให้อธิบายลักษณะโครงการที่ดำเนินการอยู่ เช่น
              ชื่อและที่ตั้งของโครงการ ประเภทโครงการ กลุ่มลูกค้าเป้าหมาย
              จำนวนหน่วย พื้นที่ขาย/ให้เช่า มูลค่าโครงการ
              ความคืบหน้าในการขาย/การพัฒนาโครงการ
            </Typography>
          </Box>
        }
      />
    </>
  );
};

export default DisclosureGuidelinesIncomeStructure;
